<template>
  <div class="reports-add-jobs">
    <el-button
      v-if="!isSelect"
      style="width: 100%"
      size="small" class="add" :type="isSelect ? 'default' : 'primary'" @click="openDialog"
    >
      {{ isAuthor ? 'Сменить автора' : (isSelect ? 'Сменить исполнителя' : '+ Выбрать исполнителя') }}
    </el-button>
    <div v-else style="cursor: pointer">
      <i @click="openDialog" class="fa fa-edit"></i>
    </div>

    <el-dialog :title="isAuthor ? 'Сменить автора' : 'Выбрать исполнителя'" :visible.sync="dialogObject">
      <div class="add-jobs">
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <strong style="text-align: left; margin-top: 20px; margin-left: 10px" v-if="filteredUserList.length">Пользователи</strong>
        <div class="jobs-ul">
          <div
            @click="save(list)"
            class="jobs-li" v-for="(list, index) in filteredUserList" :key="index"
          >
            <span>{{ list.name }}</span>
          </div>
        </div>
        <template v-if="!isAuthor">
          <strong style="text-align: left; margin-top: 20px; margin-left: 10px" v-if="filteredCompanyList.length">Компании</strong>
          <div class="jobs-ul">
            <div
              @click="save(list)"
              class="jobs-li" v-for="(list, index) in filteredCompanyList" :key="index"
            >
              <span>{{ list.name }}</span>
            </div>
          </div>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {getChildList} from '@/utils/getChild';
import _ from 'lodash';
import {filterObjects} from "../../../../utils/filterJobs";
import {getPermission} from "../../../../firestore/permission";

export default {
  name: 'AddUser',
  props: ['isSelect', 'confirmDisable', 'isAuthor'],
  data() {
    return {
      search: '',
      dialogObject: false,
      unit: '',
      role: 'admin',
      list: [],
      form: {
        value: '',
      },
    };
  },
  computed: {
    filteredUserList() {
      return this.list.filter(object => {
        return !object.isCompany && object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    filteredCompanyList() {
      return this.list.filter(object => {
        return object.isCompany && object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },

  async mounted() {
    this.fetchTree();
    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id).get().then((sub) => {
      const data = sub.data();
      if (data) {
        const rules = data.rules;
        if (rules) {
          this.role = rules[firebase.auth().currentUser.uid];

          if (data.isDemo) {
            this.role = 'admin';
          }
          this.loading = false;
        }
      }
    });
  },

  methods: {
    fetchTree() {
      this.loader = true;
      const result = [];
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            // if(!data.isCompany) {
            if(this.isAuthor) {
              result.push({
                id: data.uid,
                name: data.name || data.email,
                isCompany: data.isCompany,
                ...data
              });
            } else {
              result.push({
                id: data.uid,
                name: data.name || data.email,
                isCompany: data.isCompany,
              });
            }
            // }
          });
        }).finally(() => {
        this.list = _.uniqBy(result, 'id');
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
    openDialog() {
      if (this.confirmDisable) {
        this.$emit('add-user', null);
        return this.dialogObject = true;
      }
      if (this.isSelect) {
        this.$emit('add-user', null);
        this.dialogObject = true;
      } else {
        this.$emit('add-user', '');
        this.dialogObject = true;
      }
    },
    save(object) {
      if(this.isAuthor) {
        this.$emit('add-user', {
          name: object.name,
          id: object.id,
          ...object,
        });
      } else {

        this.$emit('add-user', {
          name: object.name,
          id: object.id,
        });
      }
      this.close();
    },
    close() {
      this.dialogObject = false;
      this.clear();
    },
    clear() {
      this.form.value = '';
    },
  },
};
</script>

<style lang="scss">
.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 0 10px;
    width: calc(100% - 20px);
    justify-content: flex-start;
    height: 48px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/components/AddUser.vue